import { Box, FormControlLabel, Switch, Typography } from '@mui/material'
import axios from 'src/utilities/http-client'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import ConfirmAction from 'src/v3/components/confirm-action'
import {
  selectSelectedLinkedService,
  errorMessageChanged,
  selectLinkedServiceById,
  fetchLinkedServices,
} from '../admin.slice'

export default ({
  setFormOpen,
  formOpen,
}: {
  setFormOpen: (arg: string) => void
  formOpen: string
}) => {
  let dispatch = useAppDispatch()
  let selectedLinkedService = useAppSelector(selectSelectedLinkedService)
  let linkedService = useAppSelector(
    selectLinkedServiceById(selectedLinkedService),
  )

  return (
    <>
      <Box className="w-full">
        <Box className="flex items-center" sx={{ minHeight: '50px' }}>
          <FormControlLabel
            label={
              <Typography
                variant="body2"
                sx={{ fontWeight: 600 }}
                color="textSecondary"
              >
                Active
              </Typography>
            }
            control={
              <Switch
                checked={linkedService?.status === 'active'}
                onChange={() => setFormOpen(`ls-status-${linkedService?.id}`)}
                color={
                  linkedService?.status === 'active' ? 'primary' : 'default'
                }
              />
            }
          />
        </Box>
      </Box>

      <ConfirmAction
        executeAction={() =>
          axios
            .put('/api/v2/admin/linked-service/status', {
              id: linkedService?.id,
              status:
                linkedService?.status === 'active' ? 'inactive' : 'active',
            })
            .then(() => dispatch(fetchLinkedServices()))
        }
        open={formOpen}
        setOpen={setFormOpen}
        openText={`ls-status-${linkedService?.id}`}
        title="Confirm Status Change"
        text={`Are you sure you want to ${
          linkedService?.status === 'active' ? 'deactivate' : 'activate'
        } ${linkedService?.name}?`}
        onFailure={(err) =>
          dispatch(
            errorMessageChanged(
              err.message || 'Error Changing Linked Service Status',
            ),
          )
        }
      />
    </>
  )
}
